import React, {createRef, useEffect, useState} from 'react';
import Api from "../../../interface/api/visit";

interface CertificateMenuOptionItem {
    innerHTML:string,
    sendType:string,
    seq:string
}
interface CertificateMenuOption {
    items:Array<CertificateMenuOptionItem>
}

export function CertificateMenuOptionItem({items}:CertificateMenuOption) {
    const [ openFlag, setOpenFlag ] = useState<boolean>(false);
    const handlerClose = (handler) => {
        setOpenFlag(false);
        try {
            handler()
        } catch (err) {

        }
    }

    const handlerOpen = (handler) => {
        setOpenFlag(true);
    }

    return (
        <>
            <div style={{position:'relative'}}>
                <button className="menu_btn_box" onClick={handlerOpen}>
                    <svg className="menu_open_dot" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                    </svg>
                </button>
            </div>
            {
                openFlag &&
                <OpenBtnBox
                    CertificateMenuOption={items}
                    handlerClose={handlerClose} />
            }
        </>
    )
}

function OpenBtnBox({ CertificateMenuOption, handlerClose }) {
    const hamburgerRef = createRef<any>();

    const handleClickOutside = event => {
        if (!hamburgerRef.current.contains(event.target)) { // 3. outside click 인지 판단
            handlerClose();
        }
    };

    function smsSendHandler(sendType, visitorSeq) {
        switch (sendType) {
            case '수료증등록' :
                Api.visitorCertificateSend(visitorSeq).then(() => {
                    alert('유해화학물질 수료증 등록 안내 문자가 발송되었습니다.')
                });
                break;
            case '재수료' :
                Api.visitorCertificateRemind(visitorSeq).then(() => {
                    alert('유해화학물질 교육 재이수 안내 문자가 발송되었습니다.')
                });
                break;
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [])

    return (
        <>
            <div className="openSelectBox" ref={hamburgerRef}>
                <ul >
                    {
                        CertificateMenuOption.map((row, index) => (
                            <li key={`menuOptionItemsKey-${index}`}
                                onClick={() => handlerClose(smsSendHandler(row.sendType, row.seq))}>{row.innerHTML}</li>
                                // onClick={() => handlerClose(row.onClickHandler)}>{row.innerHTML}</li>
                        ))
                    }
                    <li onClick={handlerClose}>닫기</li>
                </ul>
            </div>
        </>
    )
}